export default __webpack_public_path__ + "static/media/JONY-BELTRAN.b443d24f.png";